import { NgModule, ModuleWithProviders, InjectionToken } from '@angular/core';
import { JaakrecogLivenessLibComponent } from './jaakrecog-liveness-lib.component';
import { CaptureVideoComponent } from './capture-video/capture-video.component';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { JaakrecogLivenessLibService } from './jaakrecog-liveness-lib.service';
import { LoadingComponent } from './components/loading/loading.component';
import { MatDialogModule } from '@angular/material/dialog';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
export interface LibConfig {
  apiUrl: string;
}

export const LibConfigService = new InjectionToken<LibConfig>('LibConfig');
@NgModule({
  declarations: [
    JaakrecogLivenessLibComponent,
    CaptureVideoComponent,
    LoadingComponent,
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    MatDialogModule,
    BrowserAnimationsModule,
  ],
  exports: [
    JaakrecogLivenessLibComponent,
    CaptureVideoComponent,
    LoadingComponent,
  ],
})
export class JaakrecogLivenessLibModule {
  static forRoot(
    config: LibConfig
  ): ModuleWithProviders<JaakrecogLivenessLibModule> {
    return {
      ngModule: JaakrecogLivenessLibModule,
      providers: [
        JaakrecogLivenessLibService,
        {
          provide: LibConfigService,
          useValue: config,
        },
      ],
    };
  }
}
